/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import teachableMachine_IconURL from './teachable-machine-blocks.png';
import teachableMachine_InsetIconURL from './teachable-machine-blocks-small.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Teachable Machine"
        description="name for the Teachable Machine extension"
        id="extension.teachableMachine.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Use your Teachable Machine models in your Scratch project!"
        description="description for the Teachable Machine extension"
        id="extension.teachableMachine.description"
    />
  ),
	iconURL: teachableMachine_IconURL,
	insetIconURL: teachableMachine_InsetIconURL,
	tags: ["Dancing with AI","Made by PRG"],
	featured: true,
	extensionId: 'teachableMachine',
}